import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import store from "./store"
import { isMobile } from "react-device-detect"
import DeviceOrientation, { Orientation } from "react-screen-orientation"
import { Container } from "reactstrap"
import localJsonData from "./assets/localdata.json"

const loader = document.querySelector(".loader")

const showLoader = () => loader.classList.remove("loader--hide")
const hideLoader = () => loader.classList.add("loader--hide")

const allDeviceSupport = false

const renderApp = () => {
  const isAuditoriumPage =
    window.location.pathname.startsWith("/page/auditorium")
  const isPortraitPage =
    window.location.pathname == "/login" ||
    window.location.pathname == "/home" ||
    (localStorage.getItem("authUser") ? false : window.location.pathname == "/")

  const app = (
    <Provider store={store}>
      <BrowserRouter>
        {allDeviceSupport ? (
          <App hideLoader={hideLoader} showLoader={showLoader} />
        ) : isMobile && (isPortraitPage || isAuditoriumPage) ? (
          isAuditoriumPage ? (
            <DeviceOrientation lockOrientation={"landscape"}>
              {/* Auditorium - Show content in landscape */}
              <Orientation orientation="landscape" alwaysRender={false}>
                <App hideLoader={hideLoader} showLoader={showLoader} />
              </Orientation>
              {/* Show rotation message when in portrait */}
              <Orientation orientation="portrait" alwaysRender={false}>
                <Container
                  style={{
                    padding: 0,
                    position: "relative",
                    width: "100%",
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "black",
                  }}
                  fluid
                >
                  <div
                    style={{
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        marginBottom: "20px",
                        color: "#fff",
                      }}
                    >
                      📱 Please Rotate Your Device
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        color: "#ccc",
                        marginBottom: "20px",
                      }}
                    >
                      Auditorium works best in landscape mode
                    </div>
                    <div
                      style={{
                        width: "80px",
                        height: "80px",
                        border: "3px solid #007bff",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "40px",
                        animation: "rotate-animation 2s infinite",
                      }}
                    >
                      📱
                    </div>
                  </div>
                  <style>{`
                  @keyframes rotate-animation {
                    0% { transform: rotate(0deg); }
                    50% { transform: rotate(-90deg); }
                    100% { transform: rotate(0deg); }
                  }
                `}</style>
                </Container>
              </Orientation>
            </DeviceOrientation>
          ) : (
            <DeviceOrientation lockOrientation={"portrait"}>
              {/* Login/Home - Show content in portrait */}
              <Orientation orientation="portrait" alwaysRender={false}>
                <App hideLoader={hideLoader} showLoader={showLoader} />
              </Orientation>
              {/* Show rotation message when in landscape */}
              <Orientation orientation="landscape" alwaysRender={false}>
                <Container
                  style={{
                    padding: 0,
                    position: "relative",
                    width: "100%",
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "white",
                  }}
                  fluid
                >
                  <div
                    style={{
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        marginBottom: "20px",
                        color: "#333",
                      }}
                    >
                      📱 Please Rotate Your Device
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        color: "#666",
                        marginBottom: "20px",
                      }}
                    >
                      This app works best in portrait mode
                    </div>
                    <div
                      style={{
                        width: "80px",
                        height: "80px",
                        border: "3px solid #007bff",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "40px",
                        animation: "rotate-animation 2s infinite",
                      }}
                    >
                      📱
                    </div>
                  </div>
                  <style>{`
                  @keyframes rotate-animation {
                    0% { transform: rotate(0deg); }
                    50% { transform: rotate(-90deg); }
                    100% { transform: rotate(0deg); }
                  }
                `}</style>
                </Container>
              </Orientation>
            </DeviceOrientation>
          )
        ) : (
          <App hideLoader={hideLoader} showLoader={showLoader} />
        )}
      </BrowserRouter>
    </Provider>
  )

  //

  ReactDOM.render(app, document.getElementById("root"))
}

// let authUser = JSON.parse(localStorage.getItem("authUser"))

// if (authUser) {
//     let user = {
//       Firstname: authUser.Firstname,
//       EmployeeID: authUser.EmployeeID,
//       Email: authUser.Email,
//       Location: authUser.Location,
//       PhoneNumber: authUser.PhoneNumber,
//       ProfileImg: authUser.ProfileImg,
//       Token: authUser.Token
//         ? authUser.Token
//         : localStorage.getItem("notificationToken"),
//       customaction: "Login",
//     }
//     // loginUser(user)
// }
let authUser = JSON.parse(localStorage.getItem("birlaincomeSuraksha25april1"))

if (!authUser) {
  localStorage.clear()
  localStorage.setItem("birlaincomeSuraksha25april1", true)
}

async function loginUser(user) {
  const adminPanel = isMobile
    ? `${process.env.REACT_APP_ADMIN}`
    : `${process.env.REACT_APP_ADMIN_LAPTOP}`

  try {
    const response = await fetch(`${adminPanel}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(user),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const data = await response.json()
    localStorage.removeItem("authUser")
    localStorage.setItem("authUser", JSON.stringify(data))
  } catch (error) {
    console.log("Error during login:", error)
  }
}

const fetchAndStoreData = async () => {
  const adminPanel = isMobile
    ? `${process.env.REACT_APP_ADMIN}`
    : `${process.env.REACT_APP_ADMIN_LAPTOP}`

  try {
    const response = await fetch(`${adminPanel}/getJD`)
    const data = await response.json()
    localStorage.removeItem("dataJ")
    localStorage.setItem("dataJ", JSON.stringify(data))
  } catch (error) {
    console.error("Failed to fetch data:", error)
  }
  hideLoader()
  renderApp()
}

showLoader()
fetchAndStoreData()

serviceWorker.unregister()
// serviceWorker.register()
